import React from "react"
import { Redirect } from "react-router-dom"

// Profile
import UserProfile from "../pages/Authentication/user-profile"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"
import ResetPassword from "../pages/Authentication/ResetPassword"
import LockScreen from "../pages/Authentication/LockScreen"

// Dashboard
import Dashboard from "../pages/Dashboard/index"
import Appointment from "../pages/Appointment/index"
import Accounts from "../pages/Accounts/index"
import Patient from "../pages/Patient/index"
import PatientDetails from "../pages/Patient/patientDeatails"
import Settings from "pages/Settings"
import Reports from "pages/Reports"
import WelcomeClinicScreen from "pages/clinics"
import WelcomeChairScreen from "pages/chairs"
import verifyEmail from "pages/verifyEmail"
import PatientSummary from "pages/Patient/components/summary"
import ClinicLandingPage from "pages/Public/ClinicLandingPage"
import DoctorPublicProfile from "pages/Public/DoctorPublicProfile"
import PatientPortal from "pages/PatientPortal"
import TasksNotifications from "pages/TasksNotifications"
import SuperAdmin from "pages/SuperAdmin"
import TenantSubscriptionPage from "pages/Subscription/TenantSubscriptionPage"
import SubscriptionSuccessPage from "pages/Subscription/SubscriptionSuccessPage"
import SubscriptionFailurePage from "pages/Subscription/SubscriptionFailurePage"

// Accounts
import ManagePettyCash from "../pages/Accounts/ManageAccounts/ManagePettyCash"

const authProtectedRoutes = [
  { path: "/superadmin/:tab/:subParam", component: SuperAdmin },
  { path: "/superadmin/:tab", component: SuperAdmin },
  { path: "/superadmin", component: SuperAdmin },
  { path: "/subscription/success", component: SubscriptionSuccessPage },
  { path: "/subscription/failure", component: SubscriptionFailurePage },
  { path: "/subscription", component: TenantSubscriptionPage },
  { path: "/clinics", component: WelcomeClinicScreen },
  { path: "/chairs", component: WelcomeChairScreen },
  { path: "/dashboard", component: Dashboard },
  { path: "/tasks-notifications", component: TasksNotifications },
  { path: "/appointment", component: Appointment },
  { path: "/appointments", component: Appointment },
  { path: "/patients", component: Patient },
  { path: "/patient", component: PatientDetails },
  { path: "/reports/:category/:report", component: Reports },
  { path: "/reports/:category", component: Reports },
  { path: "/reports", component: Reports },
  { path: "/accounts/:tab", component: Accounts },
  { path: "/accounts", component: Accounts },
  { path: "/settings/:category/:module", component: Settings },
  { path: "/settings/:category", component: Settings },
  { path: "/settings", component: Settings },
  { path: "/patinet/summary/:id", component: PatientSummary },
  { path: "/portal", component: PatientPortal },

  // //profile
  { path: "/profile", component: UserProfile },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  { path: "/", exact: true, component: () => <Redirect to="/dashboard" /> },
]

const publicRoutes = [
  { path: "/doctor/:doctorCode", component: DoctorPublicProfile },
  { path: "/dr/:doctorCode", component: DoctorPublicProfile },
  { path: "/clinic/:slug", component: ClinicLandingPage },
  { path: "/book/:slug", component: ClinicLandingPage },
  { path: "/lock-screen", component: LockScreen },
  { path: "/auth-lock-screen", component: LockScreen },
  { path: "/verify", component: verifyEmail },
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/forgot-password", component: ForgetPwd },
  { path: "/reset-password", component: ResetPassword },
  { path: "/register", component: Register },
]

export { publicRoutes, authProtectedRoutes }
